import { notification } from '../constants';
import notificationService from '../services/notification';

export const fetchNotificationRequest = () => ({
  type: notification.FETCH_NOTIFICATION_REQUEST
});

export const fetchNotificationSuccess = notifications => ({
  type: notification.FETCH_NOTIFICATION_SUCCESS,
  notifications
});

export const fetchNotificationFailure = error => ({
  type: notification.FETCH_NOTIFICATION_FAILED,
  error
});

export const fetchNotificationStatusReset = () => ({
  type: notification.FETCH_NOTIFICATION_STATUS_RESET
});

export const fetchNotifications = (page = 1, pageSize = 20, sort, filter) => async (
  dispatch,
  getState
) => {
  dispatch(fetchNotificationRequest());

  const token = getState().user.accessToken;

  let res;

  try {
    res = await notificationService.getNotifications(token, page, pageSize, sort, filter);

    if (typeof res === 'object') {
      if (res.status === 200) {
        dispatch(
          fetchNotificationSuccess({
            histories: res.data.Result.histories,
            total: res.data.Result.total,
            page,
            pageSize,
            sort,
            filter
          })
        );
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          fetchNotificationFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(fetchNotificationFailure(e));
  }

  return res;
};
